// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__RCQDU","loaderOuter":"PageOverlayLoader_loaderOuter__3_dXb"};